import { getWineName } from '@vivino/js-web-common';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { fetchTastesByWineId } from 'vivino-js/api/taste';
import { vintage } from 'vivino-js/apiPropTypes';

import TasteCharacteristicsPresentational from './TasteCharacteristics.presentational';
import TasteCharacteristicsSkeleton from './TasteCharacteristics.skeleton';

const TasteCharacteristics = ({ vintage, tastes: tastesProps }) => {
  const wineId = vintage?.wine?.id;
  const [isLoading, setIsLoading] = useState(true);
  const [tastes, setTastes] = useState(tastesProps);

  useEffect(() => {
    if (wineId && !tastesProps) {
      fetchTastesByWineId({ wineId })
        .then(({ tastes }) => {
          setTastes(tastes);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  }, [wineId, tastesProps]);

  if (isLoading && !tastes) {
    return <TasteCharacteristicsSkeleton />;
  }

  if (!tastes?.structure && !tastes?.flavor) {
    return null;
  }

  const wineName = getWineName(vintage.wine);

  return (
    <TasteCharacteristicsPresentational
      tastes={tastes}
      vintageYear={vintage.year}
      wineName={wineName}
      wineId={wineId}
    />
  );
};

TasteCharacteristics.propTypes = {
  vintage,
  tastes: PropTypes.object,
};

export default TasteCharacteristics;
